/**
 * Phase 105-Agent-B — Shared Google Maps deep-link helper.
 *
 * Hard rule across the app: Google Maps appears only as an external
 * deep-link, never as an embedded map. This module centralises the
 * URL construction so we have ONE place to change if the param schema
 * evolves.
 */

/** Build a Google Maps directions URL to a destination.
 *  Prefers lat/lng pair; falls back to URL-encoded address text. */
export function gmapsDirectionsUrl({ lat, lng, address } = {}) {
  const base = "https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=";
  if (lat != null && lng != null && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
    return `${base}${Number(lat)},${Number(lng)}`;
  }
  if (address && String(address).trim()) {
    return `${base}${encodeURIComponent(String(address).trim())}`;
  }
  return null;
}

/** Convenience for the agent task object shape used across the dashboard. */
export function gmapsForTask(task, leg = "pickup") {
  if (!task) return null;
  if (leg === "pickup") {
    const lat = task?.pickup_location?.lat ?? task?.pickup_lat;
    const lng = task?.pickup_location?.lng ?? task?.pickup_lng;
    return gmapsDirectionsUrl({ lat, lng, address: task.pickup_address });
  }
  const lat = task?.delivery_location?.lat ?? task?.delivery_lat;
  const lng = task?.delivery_location?.lng ?? task?.delivery_lng;
  return gmapsDirectionsUrl({ lat, lng, address: task.delivery_address });
}
